import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import { LINK_XRATES } from '../../constants/link_constants'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const XratesListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.XRATES)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)'
          onClick={() => store.goTo('entity_detail', { entityname: 'contracts', id: row[attr] })}>
          <span className='glyphicon glyphicon-share-alt' />&nbsp;{text} | {row[attr]}
        </a>
      )
      return <OptionsField
        attr={attr}
        val={row[attr]}
        options={store.options.get('contracts')}
        labelattr='name'
        valueattr='id'
        Component={DetailLink}
      />
    },
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('Platforms')}
      labelattr='text'
      valueattr='value' />
    ),
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('ContractCurrency')}
      labelattr='text'
      valueattr='value' />
    ),
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('ContractCurrency')}
      labelattr='text'
      valueattr='value' />
    ),
    (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={7} />), // exchange rate field
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__(defaultConst.TITLE_DELETE)}</button>
    )
  }

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    contract_id: {
      title: 'Contract',
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        labelattr={i => (i.name + ' | ' + i.id)}
        valueattr='id'
        optionsattr={'contracts'} />)
    },
    platform: {
      title: 'Platform',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'Platforms'} />)
    },
    currency_from: {
      title: 'From',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'ContractCurrency'} />)
    },
    currency_to: {
      title: 'To',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'ContractCurrency'} />)
    },
    exchange_rate: {
      title: 'Rate',
      component: (props) => (<TextInput {...props} />)
    },
    month: {
      title: 'Month',
      component: (props) => (<TextInput {...props} />)
    },
    year: {
      title: 'Year',
      component: (props) => (<TextInput {...props} />)
    }
  }

  // TODO: remove initOrder
  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_XRATES)}
    initOrder={{
      year: 'desc',
      month: 'desc',
      platform: 'asc',
      currency_from: 'asc',
      currency_to: 'asc'
    }}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />
  )
}
export default observer(XratesListView)
